import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { FaRegCalendarAlt } from 'react-icons/fa';
import CardRaw from 'v3/components/Card';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import Tooltip from 'v3/components/Tooltip';
import theme from 'v3/theme';

function fmtDate(d) {
  if (!d) return '—';
  try {
    const date = new Date(d);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch {
    return d;
  }
}

export default function Card({ group }) {
  const idOrCgc =
    group?.id ?? group?.cgcCpf ?? group?.cnpjPrincipal ?? group?.cnpj;

  const empresas = group?.empresasVinculadas ?? [];

  const empresasCount =
    group?.quantidadeEmpresas ??
    (Array.isArray(empresas) ? empresas.length : 0);

  return (
    <Col xs={12} md={6}>
      <CardRaw
        header={
          <div className="d-flex align-items-center">
            <Tooltip
              content={
                <Text type="label">{group?.nome || group?.razaoSocial}</Text>
              }
            >
              <Text
                transform="uppercase"
                color="dark"
                type="regular"
                weight="600"
                fontSize="16px"
              >
                {(group?.nome || group?.razaoSocial || '—').substring(0, 40)}
                {(group?.nome || group?.razaoSocial || '').length > 40 && '…'}
              </Text>
            </Tooltip>
          </div>
        }
        HeaderRightComponent={
          <Link to={`/grupos-empresariais/${idOrCgc}`}>
            <Button className="py-2">
              <Text
                color="white"
                type="regular"
                weight="500"
                fontSize="14px"
              >
                Detalhes
              </Text>
            </Button>
          </Link>
        }
      >
        <div
          className="d-flex align-items-center"
          style={{ gap: 8, paddingTop: 4, paddingBottom: 4 }}
        >
          <FaRegCalendarAlt color={theme.colors.gray} size={16} />
          <Text type="label" color="gray" fontSize="14px">
            Vencimento:&nbsp;
          </Text>
          <Text
            type="label"
            color="dark"
            weight="600"
            fontSize="14px"
          >
            {fmtDate(group?.vencimento || group?.vencimentoLimite)}
          </Text>
        </div>

        <div
          className="mt-2 pt-2 border-top d-flex align-items-center justify-content-between"
          style={{ borderTopColor: '#edf2f7' }}
        >
          <Text type="label" color="gray" fontSize="14px">
            Empresas vinculadas
          </Text>
          <Text
            type="regular"
            color="dark"
            weight="600"
            fontSize="14px"
          >
            {empresasCount}
          </Text>
        </div>
      </CardRaw>
    </Col>
  );
}